{
    "survey_footer": "Al enviar, aceptas los <a href=\"{terms_conditions_link}\" class=\"{link_class}\" target=\"_blank\">Términos y condiciones</a>, <a href=\"{privacy_policy_link}\" class=\"{link_class}\" target=\"_blank\">la Política de privacidad</a> y recibir comunicaciones por correo electrónico de MAJORITY."
}